import { atom } from "jotai";

export const notificationEnabledState = atom<boolean>();
